import { useContext } from 'react';
import { ThemeContext } from '../../theme/ThemeProvider.js';

/* Das DV-Logo — nur in der Fassung des aktuellen Farbschemas.

   Vorher standen beide Fassungen im DOM und eine war per CSS versteckt;
   der Browser lud trotzdem beide, und die helle war ein 260-KB-PNG
   (532×760) für 44 bzw. 190 px Höhe. Jetzt WebP in ein- bis dreifacher
   Anzeigegröße: Seitenleiste 7 KB, Anmeldeseite 24 KB. Die weiße Fassung
   bleibt SVG.

   Die Klassen übergibt der Aufrufer, weil Seitenleiste und Anmeldeseite
   ihre Logos unterschiedlich setzen (SideNav.css, LoginPage.css). */
const FASSUNGEN = {
  // [Datei, Breite, Höhe] — Breite/Höhe nur fürs Seitenverhältnis, damit
  // vor dem Laden nichts springt; die Höhe setzt das CSS.
  klein: { hell: ['logo-dv-132.webp', 31, 44], dunkel: ['logo-dv-weiss.svg', 29, 44] },
  gross: { hell: ['logo-dv-380.webp', 133, 190], dunkel: ['logo-dv-weiss.svg', 127, 190] },
};

export function DvLogo({ groesse = 'klein', hellKlasse, dunkelKlasse, alt = 'DV Limburg', ...rest }) {
  const { theme } = useContext(ThemeContext);
  const dunkel = theme === 'dunkel';
  const [datei, breite, hoehe] = FASSUNGEN[groesse][dunkel ? 'dunkel' : 'hell'];
  return (
    <img
      src={`${process.env.PUBLIC_URL}/${datei}`}
      alt={alt}
      className={dunkel ? dunkelKlasse : hellKlasse}
      width={breite}
      height={hoehe}
      // Auf der Anmeldeseite ist das Logo das größte Bild.
      fetchPriority={groesse === 'gross' ? 'high' : undefined}
      {...rest}
    />
  );
}
